<div
  [class.map-full-screen]="isFullScreen"
  class="wrapper"
  >
  <div
    class="left"
    >
    <app-map-wrapper class="map">
      <router-outlet name="map"></router-outlet>
    </app-map-wrapper>
    @if (showAddDiv && !isFullScreen && editable && (actingRole !== 'contractor-basic' && actingRole !== 'reviewer')) {
      <div
        #triggerMenu="cdkOverlayOrigin"
        (click)="editable ? handleAdd() : {}"
        [matTooltipDisabled]="editable"
        [matTooltip]="'Editing disabled'"
        [ngClass]="{ 'disabled': !editable }"
        cdkOverlayOrigin
        class="add-button"
        >
        <mat-icon svgIcon="add" />
        <ng-template
          (backdropClick)="isDailyReportMenuOpen = false"
          [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
          [cdkConnectedOverlayHasBackdrop]="true"
          [cdkConnectedOverlayOpen]="isDailyReportMenuOpen"
          [cdkConnectedOverlayOrigin]="triggerMenu"
          cdkConnectedOverlay
          >
          @if (pageSlug === 'daily-report') {
            <div
              class="daily-report-menu"
              >
              @for (eachConfig of dailyReportMenuConfig; track eachConfig; let first = $first; let last = $last) {
                <div
                  (click)="eachConfig.handler()"
                  [class.first]="first"
                  [class.last]="last"
                  class="each-menu-option flex justify-start items-center gap-[8px] h-[48px] cursor-pointer"
                  >
                  <mat-icon [svgIcon]="eachConfig.icon" />
                  <div class="menu-label text-type-10">{{ eachConfig.label }}</div>
                </div>
              }
            </div>
          }
        </ng-template>
      </div>
    }
    <!-- Daily diary gets its own floating +: same button/geometry as the
         daily-report one above, but gated on the DailyDiary create ability
         rather than the daily-report editable/actingRole rules. -->
    @if (showDiaryAddDiv && !isFullScreen) {
      <div
        #diaryTriggerMenu="cdkOverlayOrigin"
        (click)="handleAddDiary()"
        cdkOverlayOrigin
        class="add-button"
        data-testid="new-daily-diary-btn"
        >
        <mat-icon svgIcon="add" />
        <!-- On an open diary this + adds a component to it, so it drops the
             same menu the daily report's + does. -->
        <ng-template
          (backdropClick)="isDailyDiaryMenuOpen = false"
          [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
          [cdkConnectedOverlayHasBackdrop]="true"
          [cdkConnectedOverlayOpen]="isDailyDiaryMenuOpen"
          [cdkConnectedOverlayOrigin]="diaryTriggerMenu"
          cdkConnectedOverlay
          >
          <div class="daily-report-menu" data-testid="diary-component-menu">
            @for (eachConfig of dailyDiaryMenuConfig; track eachConfig; let first = $first; let last = $last) {
              <div
                (click)="eachConfig.handler()"
                [class.first]="first"
                [class.last]="last"
                class="each-menu-option flex justify-start items-center gap-[8px] h-[48px] cursor-pointer"
                >
                <mat-icon [svgIcon]="eachConfig.icon" />
                <div class="menu-label text-type-10">{{ eachConfig.label }}</div>
              </div>
            }
          </div>
        </ng-template>
      </div>
    }
    @if (!isFullScreen) {
      <div
        [class.sidenav-open]="showSidenav"
        class="content"
        >
        <router-outlet name="content" />
      </div>
    }
  </div>
  @if (showSidenav) {
    <div
      [@rightAnimation]="showSidenav ? 'sidenavOpen' : 'sidenavClosed'"
      class="right"
      data-drawings-drawer
      >
      @if (!isLevelThreeMarkerClicked) {
        <div class="close-block">
          <mat-icon
            (click)="close()"
            class="close-icon"
            data-testid="right-panel-close"
            svgIcon="close"
            />
        </div>
      }
      @if (isLevelThreeMarkerClicked) {
        <div class="close-block-backarrow">
          <img
            (click)="goBack()"
            alt="circle-back.png"
            class="back-icon"
            src="./assets/icons/circle-back.png" />
          <img
            (click)="close()"
            alt="circle-close.png"
            class="close-icon"
            src="./assets/icons/circle-close.png" />
        </div>
      }
      <ng-container #container></ng-container>
    </div>
  }
</div>
